import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import arrowIcon from "./img/arrow.png";
import plusIcon from "./img/plus.png";
import gearIcon from "./img/gear.png";
import trashIcon from "./img/trash.webp";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { fieldTypes } from "./globalVariables";
import { useConfig } from "./ConfigContext";

const emptyFeld = {
   type: "",
   onOffice: "",
   name: "neues_feld",
   title: "",
   buttonName: "",
   optional: false,
   readOnly: false,
   respField: "",
   options: "",
   dependency: "",
   channelId: "",
};

export default function KachelEdit({ rowIndex, colIndex, data, allKacheln, setAllKacheln, fieldconfiguration }) {
   const [showEdit, setShowEdit] = useState(false);
   const [felder, setFelder] = useState(
      allKacheln[data.projektId].kachel.filter((item) => item.kachelId === data.kachelId)[0].layout,
   );

   function addFeld(x, y) {
      // setShow(true);

      let newFelder = structuredClone(
         allKacheln[data.projektId].kachel.filter((item) => item.kachelId === data.kachelId)[0].layout,
      );
      let element = {
         type: "text",
         heading: "Neues Feld",
         name: parseInt(new Date().getTime() / 1000),
         readOnly: true,
      };
      insertFeld(x, y, element, newFelder);
      let kachelIndex = allKacheln[data.projektId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.projektId].kachel[kachelIndex].layout = newFelder;
      setAllKacheln(newKacheln);
   }

   function editFeld() {
      setShowEdit(true);
      // setFeldData(data);
   }

   function saveFeld(newData) {
      let kachelIndex = allKacheln[data.projektId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.projektId].kachel[kachelIndex].layout[rowIndex][colIndex] = newData;
      setAllKacheln(newKacheln);
   }

   function shiftFeld(x, y) {
      let newFelder = structuredClone(
         allKacheln[data.projektId].kachel.filter((item) => item.kachelId === data.kachelId)[0].layout,
      );

      const element = newFelder[rowIndex].splice(colIndex, 1)[0];
      insertFeld(x, y, element, newFelder);
      let kachelIndex = allKacheln[data.projektId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.projektId].kachel[kachelIndex].layout = newFelder;
      setAllKacheln(newKacheln);
   }

   function removeFeld() {
      let newFelder = structuredClone(
         allKacheln[data.projektId].kachel.filter((item) => item.kachelId === data.kachelId)[0].layout,
      );

      const element = newFelder[rowIndex].splice(colIndex, 1)[0];
      let kachelIndex = allKacheln[data.projektId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.projektId].kachel[kachelIndex].layout = newFelder;
      setAllKacheln(newKacheln);
   }

   function insertFeld(x, y, element, newFelder) {
      if (x > 0) {
         newFelder[rowIndex].splice(colIndex + 1, 0, element)[0];
      } else if (x < 0) {
         newFelder[rowIndex].splice(colIndex - 1, 0, element)[0];
      } else if (y < 0) {
         if (newFelder[rowIndex - 1]) {
            newFelder[rowIndex - 1].splice(
               newFelder[rowIndex - 1].length > colIndex ? colIndex : newFelder[rowIndex - 1].length,
               0,
               element,
            )[0];
         } else {
            newFelder.unshift([element]);
         }
      } else if (y > 0) {
         if (newFelder[rowIndex + 1]) {
            newFelder[rowIndex + 1].splice(
               newFelder[rowIndex + 1].length > colIndex ? colIndex : newFelder[rowIndex + 1].length,
               0,
               element,
            )[0];
         } else {
            newFelder.push([element]);
         }
      }
   }

   return (
      <div className="kachel-edit">
         {showEdit && (
            <EditModal
               show={showEdit}
               setShow={setShowEdit}
               data={allKacheln[data.projektId].kachel.filter((item) => item.kachelId === data.kachelId)[0].layout}
               rowIndex={rowIndex}
               colIndex={colIndex}
               saveFeld={saveFeld}
               fieldconfiguration={fieldconfiguration}
            />
         )}
         <div>
            <button
               className="kachel-edit-btn"
               title="Feld bearbeiten"
               style={{ position: "absolute", top: 28, right: 90, height: 40, boxShadow: "0 0 10px #0006" }}
               onClick={(e) => {
                  e.preventDefault();
                  editFeld();
               }}
            >
               <img src={gearIcon} alt="Feld bearbeiten" height={24} />
            </button>
            <button
               className="kachel-edit-btn"
               title="Feld entfernen"
               style={{ position: "absolute", top: 28, right: 40, height: 40, boxShadow: "0 0 10px #0006" }}
               onClick={(e) => {
                  e.preventDefault();
                  removeFeld();
               }}
            >
               <img src={trashIcon} alt="Feld entfernen" height={24} />
            </button>
            <div style={{ top: -24, transform: "rotate(270deg)" }} className="kachel-edit-btn-group">
               <button
                  className="kachel-edit-btn"
                  onClick={(e) => {
                     e.preventDefault();
                     addFeld(0, -1);
                  }}
               >
                  <img src={plusIcon} height={14} />
               </button>
               <button
                  className="kachel-edit-btn"
                  title="Nach oben verschieben"
                  disabled={rowIndex === 0}
                  onClick={(e) => {
                     e.preventDefault();
                     shiftFeld(0, -1);
                  }}
               >
                  <img src={arrowIcon} height={16} />
               </button>
            </div>
            <div style={{ right: -8, transform: "rotate(0deg)" }} className="kachel-edit-btn-group">
               <button
                  className="kachel-edit-btn"
                  onClick={(e) => {
                     e.preventDefault();
                     addFeld(1, 0);
                  }}
               >
                  <img src={plusIcon} height={14} />
               </button>
               <button
                  className="kachel-edit-btn"
                  title="Nach rechts verschieben"
                  onClick={(e) => {
                     e.preventDefault();
                     shiftFeld(1, 0);
                  }}
               >
                  <img src={arrowIcon} height={16} />
               </button>
            </div>

            <div style={{ bottom: -24, transform: "rotate(90deg)" }} className="kachel-edit-btn-group">
               <button
                  className="kachel-edit-btn"
                  onClick={(e) => {
                     e.preventDefault();
                     addFeld(0, 1);
                  }}
               >
                  <img src={plusIcon} height={14} />
               </button>
               <button
                  className="kachel-edit-btn"
                  title="Nach unten verschieben"
                  onClick={(e) => {
                     e.preventDefault();
                     shiftFeld(0, 1);
                  }}
               >
                  <img src={arrowIcon} height={16} />
               </button>
            </div>
            <div style={{ left: -8, transform: "rotate(180deg)" }} className="kachel-edit-btn-group">
               <button
                  className="kachel-edit-btn"
                  onClick={(e) => {
                     e.preventDefault();
                     addFeld(-1, 0);
                  }}
               >
                  <img src={plusIcon} height={14} />
               </button>
               <button
                  className="kachel-edit-btn"
                  title="Nach links verschieben"
                  disabled={colIndex === 0}
                  onClick={(e) => {
                     e.preventDefault();
                     shiftFeld(-1, 0);
                  }}
               >
                  <img src={arrowIcon} height={16} />
               </button>
            </div>
         </div>
      </div>
   );
}

export function KachelEditForm({ data, allKacheln, setAllKacheln, fieldconfiguration }) {
   const [settings, setSettings] = useState(data);

   function editSettings(name, value) {
      setSettings((prev) => ({ ...prev, [name]: value }));
   }
   const [projektIds, setProjektIds] = useState(
      Object.keys(allKacheln).reduce((oldObj, item) => ({ ...oldObj, [item]: allKacheln[item].projektHeading }), {}),
   );

   return (
      <div className="kachel-edit-menu">
         <h2>Kacheleinstellungen</h2>
         <Form className="mt-4">
            <Row>
               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Initialer Name der Kachel</Form.Label>
                  <Form.Control
                     placeholder="z.B. Datenblatt"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     value={settings.heading}
                     name={"heading"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Kachel-Kürzel (2 Buchstaben)</Form.Label>
                  <Form.Control
                     placeholder="z.B. EW"
                     maxLength={2}
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     value={settings.kachelkuerzel}
                     name={"kachelkuerzel"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3 ">
                  <Form.Label>Übergeordnete Projektstufe</Form.Label>

                  <Form.Select
                     value={settings.projektId}
                     name={"projektId"}
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                  >
                     <option value=""></option>
                     {Object.keys(projektIds).map((item) => {
                        return <option value={item}>{projektIds[item]}</option>;
                     })}
                  </Form.Select>
               </Form.Group>
            </Row>
            <Row>
               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Standard-Eskalationsfrist (in Tagen)</Form.Label>
                  <Form.Control
                     value={settings.standardEskalationsfrist}
                     type="number"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     name={"standardEskalationsfrist"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Maximale-Eskalationsfrist (in Tagen)</Form.Label>
                  <Form.Control
                     value={settings.maxEskalationsfrist}
                     type="number"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     name={"maxEskalationsfrist"}
                  />
               </Form.Group>
            </Row>
            <Row>
               <Form.Group as={Col} className="mb-3" controlId="pflichtKachel">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="Pflichtkachel"
                     name="pflichtKachel"
                     checked={settings.pflichtKachel}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"pflichtKachel"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3" controlId="pflichtEskalation">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="Pflicht-Eskalation"
                     name="pflichtEskalation"
                     checked={settings.pflichtEskalation}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"pflichtEskalation"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3" controlId="adminFreigabe">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="mit Admin-Freigabe"
                     name="adminFreigabe"
                     checked={settings.adminFreigabe}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"adminFreigabe"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3" controlId="pmFreigabe">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="mit Projektmanager-Freigabe"
                     name="pmFreigabe"
                     checked={settings.pmFreigabe}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"pmFreigabe"}
                  />
               </Form.Group>
               <Form.Group as={Col} className="mb-3" controlId="optional">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="optional (standardmäßig ausgeblendet)"
                     name="optional"
                     checked={settings.optional}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"optional"}
                  />
               </Form.Group>
            </Row>
            <Row>
               <Form.Group as={Col} className="mb-3" controlId="hinweis">
                  <Form.Label>Hinweistext (wird oben in der Kachel angezeigt und HTML-Formatierung möglich)</Form.Label>
                  <Form.Control
                     autoComplete="off"
                     placeholder=""
                     style={{ minHeight: "115px", fieldSizing: "content" }}
                     as="textarea"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     name="title"
                     value={settings.hinweis}
                  />
               </Form.Group>
            </Row>
         </Form>
         <div className="d-flex justify-content-end mt-2">
            <Button
               variant="secondary"
               onClick={() => {
                  localStorage.setItem("build", 0);
                  window.location.reload();
               }}
            >
               Kacheln zurücksetzen
            </Button>
            <Button
               onClick={() => {
                  let kachelIndex = allKacheln[data.projektId].kachel.findIndex(
                     (item) => item.kachelId === data.kachelId,
                  );
                  console.log(kachelIndex);

                  let { layout, ...basicSettings } = settings;
                  let newKacheln = structuredClone(allKacheln);
                  newKacheln[data.projektId].kachel[kachelIndex] = {
                     ...newKacheln[data.projektId].kachel[kachelIndex],
                     ...basicSettings,
                  };
                  setAllKacheln(newKacheln);

                  downloadObjectAsJson(
                     {
                        ...newKacheln[data.projektId].kachel[kachelIndex],
                        ...basicSettings,
                     },
                     settings.kachelId + new Date().toLocaleString(),
                  );
               }}
               className="ms-1"
            >
               Herunterladen
            </Button>
            <Button
               onClick={() => {
                  let kachelIndex = allKacheln[data.projektId].kachel.findIndex(
                     (item) => item.kachelId === data.kachelId,
                  );
                  console.log(kachelIndex);

                  let { layout, ...basicSettings } = settings;
                  let newKacheln = structuredClone(allKacheln);
                  newKacheln[data.projektId].kachel[kachelIndex] = {
                     ...newKacheln[data.projektId].kachel[kachelIndex],
                     ...basicSettings,
                  };
                  setAllKacheln(newKacheln);

                  localStorage.setItem("kacheln", JSON.stringify(newKacheln));
               }}
               className="ms-1"
            >
               Speichern
            </Button>
         </div>
      </div>
   );
}

function EditModal({ setShow, show, data, rowIndex, colIndex, saveFeld, fieldconfiguration }) {
   const [feldKurzel, setFeldKurzel] = useState("");
   const [feldData, setFeldData] = useState(data[rowIndex][colIndex]);
   const config = useConfig();

   function editFeld(name, value, oOFieldData, module) {
      console.log(value);
      if (name === "onOffice") {
         setFeldData((prev) => ({
            ...prev,
            onOffice: value,
            module: module,
            name: value,
            type: oOFieldData.type,
            heading: oOFieldData.label,
            readOnly: false,
            ...(oOFieldData.length ? { maxLength: oOFieldData.length } : {}),
         }));
      } else {
         setFeldData((prev) => ({ ...prev, [name]: value }));
      }
   }

   return (
      <Modal show={show} className="" size="xl" onHide={() => setShow(false)}>
         <Modal.Header closeButton>
            <Modal.Title>Feld bearbeiten</Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <Form>
               <Row>
                  <Form.Group as={Col} className="mb-3 ">
                     <Form.Label>Ist es ein onOffice-Feld?</Form.Label>

                     <Form.Select
                        className={""}
                        name={"isOnOffice"}
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.value);
                        }}
                        value={feldData.isOnOffice}
                     >
                        <option value="">Nein</option>
                        <option value="estate">Immobilienfeld</option>
                        <option value="address">Adressenfeld</option>
                     </Form.Select>
                  </Form.Group>
                  {feldData.isOnOffice && (
                     <Form.Group as={Col} className="mb-3 ">
                        <Form.Label>onOffice-Feldname</Form.Label>

                        <Select
                           name={"onOffice"}
                           // className="form-control"
                           // classNamePrefix="react-select"
                           styles={{
                              control: (baseStyles, state) => ({
                                 ...baseStyles,
                                 // Hier änderst du den Radius
                                 borderRadius: "10px",
                                 border: "solid 2px #eee",
                                 // Optional: Rahmenfarbe bei Fokus anpassen
                                 // borderColor: state.isFocused ? "#007bff" : "#ced4da",
                              }),
                           }}
                           placeholder="..."
                           options={
                              fieldconfiguration &&
                              fieldconfiguration[feldData.isOnOffice] &&
                              Object.keys(fieldconfiguration[feldData.isOnOffice])
                                 .filter((configKey) => {
                                    let filterResult = true;
                                    const fieldObj = fieldconfiguration[feldData.isOnOffice][configKey];
                                    if (
                                       Object.values(config[feldData.isOnOffice]).includes(configKey) ||
                                       fieldObj.type === "dividingline" ||
                                       fieldObj.type === "redhint" ||
                                       fieldObj.type === "blackhint" ||
                                       fieldObj.type === "datei" ||
                                       configKey === "label"
                                    ) {
                                       filterResult = false;
                                    }

                                    return filterResult;
                                 })
                                 .map((fieldKey, index) => {
                                    return {
                                       value: fieldKey,
                                       label: fieldconfiguration[feldData.isOnOffice][fieldKey].label,
                                    };
                                 })
                                 .sort((a, b) => {
                                    if (a.label > b.label) return 1;
                                    else return -1;
                                 })
                           }
                           onChange={(e) => {
                              console.log(e);

                              editFeld(
                                 "onOffice",
                                 e.value,
                                 fieldconfiguration[feldData.isOnOffice][e.value],
                                 feldData.isOnOffice,
                              );
                           }}
                           value={
                              fieldconfiguration[feldData.isOnOffice][feldData.onOffice]
                                 ? {
                                      value: feldData.onOffice,
                                      label: fieldconfiguration[feldData.isOnOffice][feldData.onOffice].label,
                                   }
                                 : null
                           }
                        />
                     </Form.Group>
                  )}
                  {!feldData.isOnOffice && (
                     <Form.Group as={Col} className="mb-3 ">
                        <Form.Label>Typ</Form.Label>

                        <Form.Select
                           className={""}
                           name={"type"}
                           onChange={(e) => {
                              editFeld(e.target.name, e.target.value);
                           }}
                           value={feldData.type}
                        >
                           <option value=""></option>
                           {Object.keys(fieldTypes).map((fieldType, index) => {
                              return (
                                 <option value={fieldType} key={fieldType}>
                                    {fieldTypes[fieldType]}
                                 </option>
                              );
                           })}
                        </Form.Select>
                     </Form.Group>
                  )}
               </Row>
               <Row>
                  <Form.Group as={Col} className="mb-3">
                     <Form.Label>Feldname</Form.Label>
                     <Form.Control
                        placeholder="z.B. angefordert bei"
                        className={""}
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.value);
                        }}
                        name={"heading"}
                        value={feldData.heading}
                     />
                  </Form.Group>
                  {/* {!feldData.isOnOffice && (
                     <Form.Group as={Col} className="mb-3">
                        <Form.Label>
                           Feldkürzel <small>(zusammenhängend max. 16 Zeichen keine Sonderzeichen)</small>
                        </Form.Label>
                        <Form.Control
                           placeholder="z.B. anfordBei"
                           className={""}
                           maxLength={16}
                           name="name"
                           onChange={(e) => {
                              editFeld(e.target.name, e.target.value);
                              // setFeldKurzel(e.target.value);
                           }}
                           value={feldData.name}
                        />
                     </Form.Group>
                  )} */}
               </Row>

               {feldData.type === "select" && (
                  <Row>
                     <Form.Group as={Col} className="mb-3">
                        <Form.Label>
                           Auswahloptionen{" "}
                           <small>
                              mit Komma getrennt eintragen. Zusätzlich "Sonstiges" anfügen, falls optionales Textfeld
                              erwünscht.
                           </small>
                        </Form.Label>
                        <Form.Control
                           placeholder="Notariat, Bauamt, Rathaus, Sonstiges"
                           className={""}
                           onChange={(e) => {
                              editFeld(e.target.name, e.target.value.replace(/\s/g, "").split(","));
                           }}
                           name={"options"}
                           value={feldData.options ? feldData.options.join(",") : ""}
                        />
                     </Form.Group>
                  </Row>
               )}

               <Row>
                  <Form.Group as={Col} className="mb-3" controlId="optional">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="optional"
                        name="optional"
                        checked={feldData.optional}
                        type="checkbox"
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.checked);
                        }}
                        id={"optional"}
                     />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="optional">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="schreibgeschützt"
                        name="readOnly"
                        checked={feldData.readOnly}
                        type="checkbox"
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.checked);
                        }}
                        id={"readOnly"}
                     />
                  </Form.Group>
               </Row>
               <Row>
                  <Form.Group as={Col} className="mb-3" controlId="zusatzinfos">
                     <Form.Label>Hilfstext (wird beim Hovern mit der Maus über dem Feld angezeigt)</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        as="textarea"
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.value);
                        }}
                        name="title"
                        value={feldData.title}
                     />
                  </Form.Group>
               </Row>
               {/*  <Row>
                  <hr />
                  <h5 className="my-3">Feld in Abhängigkeit von Wert in anderem Feld anzeigen</h5>
                  <Form.Group as={Col} className="mb-3">
                     <Form.Label>Abhängigkeitsfeld</Form.Label>
                     <Form.Select
                        className={""}
                        name={"type"}
                        onChange={(e) => {
                           setDependency((prev) => ({ ...prev, name: e.target.value }));
                        }}
                        value={dependency.name}
                     >
                        <option value=""></option>
                        {felder.flat().map((field, index) => {
                           return (
                              <option value={field.name} key={field.name}>
                                 {field.heading}
                              </option>
                           );
                        })}
                     </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                     <Form.Label>Abhängigkeitswert</Form.Label>
                     <Form.Control
                        placeholder="z.B. Ja"
                        className={""}
                        onChange={(e) => {
                           setDependency((prev) => ({ ...prev, value: e.target.value }));
                        }}
                        value={dependency.value}
                     />
                  </Form.Group>
               </Row> */}
            </Form>
         </Modal.Body>
         <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
               Abbrechen
            </Button>
            <Button
               variant="primary"
               onClick={() => {
                  let newFeldData = { ...feldData };

                  delete newFeldData.isOnOffice;
                  if (!newFeldData.readOnly) delete newFeldData.readOnly;
                  if (!newFeldData.optional) delete newFeldData.optional;
                  saveFeld(newFeldData);
                  setShow(false);
               }}
            >
               Speichern
            </Button>
         </Modal.Footer>
      </Modal>
   );
}

function downloadObjectAsJson(exportObj, exportName) {
   // 1. Objekt in JSON-String umwandeln (mit Einrückung für Lesbarkeit)
   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj, null, 2));

   // 2. Ein unsichtbares <a> Element erstellen
   const downloadAnchorNode = document.createElement("a");
   downloadAnchorNode.setAttribute("href", dataStr);
   downloadAnchorNode.setAttribute("download", exportName + ".json");

   // 3. In den Body einfügen, klicken und wieder entfernen
   document.body.appendChild(downloadAnchorNode);
   downloadAnchorNode.click();
   downloadAnchorNode.remove();
}
